import React, { useEffect } from 'react';
import './modal.css'; // Import the updated modal styles

const Modal = ({ isOpen, onClose, children }) => {
  // Effect to prevent background scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      // Lock scroll on body and html tags
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden'; // Also prevent scroll on the HTML tag
    } else {
      // Reset scroll when modal is closed
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = 'unset'; // Reset HTML scroll behavior
    }

    // Cleanup function to reset overflow on component unmount
    return () => {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      
      <div className="modal-content">

      <button 
  className="close-button" 
  onClick={onClose} 
  style={{ margin: "10px", backgroundColor: "transparent", color: "inherit" }}
>
  &times;
</button>

        <div className="modal-body">
          
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
